



































import {
  defineComponent, defineAsyncComponent, ref, onMounted, PropType,
} from '@vue/composition-api';
import { VerifyCreditIdentityLoader, OcrIdentityLoader } from '@/shared/tools/ocr/utils/loader';
import { checkOcrMatchExperiment, checkOcrSdkInstalled } from '@/shared/tools/ocr/utils/check';
import { EntranceTypeEnum } from '@/widgets/ocr-identity/enums';
import { UploadProcessTypeEnum } from '@/shared/tools/ocr/enum';
import { ubtExposeNewOcr, TE_OCR_ENTER } from '@/shared/tools/ocr/tianqi';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { getProcessSourceForServer, getOperationSource } from '@/shared/verify-credit-controller/utils';
import { VerifyEntireTypeEnum } from '@/views_v2/verify-credit/types';

const VerifyCreditIdentity = defineAsyncComponent(VerifyCreditIdentityLoader);
const OcrIdentity = defineAsyncComponent(OcrIdentityLoader);

export default defineComponent({
  props: {
    processIsLastVerify: Boolean,
    verifyScene: {
      type: String as PropType<VerifySceneEnum>,
      required: true,
    },
    verifyEntireType: {
      type: String as PropType<VerifyEntireTypeEnum>,
      required: true,
    },
    ocrAfter: {
      type: Boolean,
      default: false,
    },
    ocrAfterLoan: {
      type: Boolean,
      default: false,
    },
    isEditAction: Boolean,
    isCheckIdentityClarityScore: Boolean,
    showSaveConfirm: Boolean,
    isLoanProcess: Boolean,
  },
  emits: [
    'resolveProcessVerify',
  ],
  components: {
    VerifyCreditIdentity,
    OcrIdentity,
  },
  setup(props, { emit }) {
    const isUseClientOcr = ref(IS_PRERENDERING ? false : undefined);
    const processSource = ref(
      getProcessSourceForServer(
        props.verifyEntireType,
        props.ocrAfter,
        props.ocrAfterLoan,
      ),
    );
    const operationSource = ref(getOperationSource(props.verifyScene));
    const onResolveProcessVerify = () => {
      emit('resolveProcessVerify');
    };

    onMounted(async () => {
      if (IS_PRERENDERING) return;

      const isMatchExperiment = checkOcrMatchExperiment();
      const isOcrSdkInstalled = await checkOcrSdkInstalled();
      isUseClientOcr.value = isMatchExperiment && isOcrSdkInstalled;

      const processType = isUseClientOcr.value
        ? UploadProcessTypeEnum.SCAN
        : UploadProcessTypeEnum.CAMERA;

      ubtExposeNewOcr(TE_OCR_ENTER, {
        // 0（实验组）/1（对照组）
        abTest: isMatchExperiment ? 0 : 1,
        // 0（下载未完成）/1（下载完成）
        sdkInstalled: isOcrSdkInstalled ? 1 : 0,
        // 来源场景
        scene: processSource,
        // 流程类型
        processType,
      });
    });

    return {
      isUseClientOcr,
      EntranceTypeEnum,
      processSource,
      operationSource,
      onResolveProcessVerify,
    };
  },
});
